import { Stack, SvgIcon, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { FunctionComponent, SVGAttributes } from 'react';

type GuideItemVariant = 'full' | 'compact';

export type TGuideItem = {
  icon: FunctionComponent<SVGAttributes<SVGElement>>;
  label: string; // Required for accessibility
  description?: string;
};

export default function GuideItem({
  item,
  variant = 'compact',
  dataComponent,
  dataTestId,
}: Readonly<{
  item: TGuideItem;
  dataTestId: string;
  variant?: GuideItemVariant;
  dataComponent?: string;
}>) {
  return (
    <Stack
      direction={variant === 'full' ? ['row', 'column'] : 'row'}
      gap={variant === 'full' ? tokens.spacingSm : 0}
      alignItems="center"
      flex={variant === 'full' ? 1 : undefined}
      aria-label={item.label}
      data-component={dataComponent}
      data-testid={dataTestId}
    >
      {variant === 'full' && (
        <SvgIcon
          sx={{
            fontSize: ['100px', '150px'],
          }}
          viewBox="0 0 151 150"
          component={item.icon}
        />
      )}

      {variant === 'compact' && (
        <SvgIcon
          sx={{
            fontSize: '100px',
          }}
          viewBox="0 0 100 100"
          component={item.icon}
        />
      )}

      {variant === 'full' && (
        <Stack gap={[tokens.spacingXs, tokens.spacingSm]} alignItems={['flex-start', 'center']}>
          <Typography variant="h6" data-record-label={item.label}>
            {item.label}
          </Typography>
          {item.description && (
            <Typography
              variant="body1"
              textAlign={['left', 'center']}
              data-record-description={item.description}
            >
              {item.description}
            </Typography>
          )}
        </Stack>
      )}
    </Stack>
  );
}
